import script from "./processTree.vue?vue&type=script&setup=true&lang=js"
export * from "./processTree.vue?vue&type=script&setup=true&lang=js"

import "./processTree.vue?vue&type=style&index=0&id=3d2c4d8f&lang=scss"

const __exports__ = script;

export default __exports__